import script from "./xt_list_item.vue?vue&type=script&setup=true&lang=js"
export * from "./xt_list_item.vue?vue&type=script&setup=true&lang=js"

import "./xt_list_item.vue?vue&type=style&index=0&id=589fcd7f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-589fcd7f"]])

export default __exports__